// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor~bundle"], () => (__webpack_require__("./main.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
